import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // 'maximum' target is defined in HAML and populated by Rails constant.
  // Controller only needs to update 'current'.
  static targets = ["input", "current"]

  initialize() {
    this.update = this.update.bind(this)
  }

  connect() {
    this.inputTarget.addEventListener("input", this.update)
    this.update() // Initial update of current count on connect
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.update)
  }

  update() {
    if (this.hasCurrentTarget) {
      this.currentTarget.textContent = this.currentLength.toString()
    }
  }

  get currentLength() {
    return this.inputTarget.value.length
  }

  // The maxLengthFromInput() and associated logic for setting maximumTarget
  // has been removed as the HAML view now solely defines the maximum display value.
  // If direct reading of a maxlength attribute from the input were needed for other logic,
  // that could be added back, but it won't set the display here.
}